<template>
  <div class="box">
    <el-row>
      <el-col :span="13">
        <span>任<span style="display: inline-block; width: 11px"></span>务<span
            style="display: inline-block; width: 11px"></span>书<span
            style="display: inline-block; width: 11px"></span>号：</span>
        <el-input v-model="pObjs.WEAVNO" clearable size="mini" disabled type="number" />
        <!-- <span>{{ pObjs.WEAVNO }}</span> -->
      </el-col>
      <el-col :span="11">
        <span>单<span style="display: inline-block; width: 11px"></span>据<span
            style="display: inline-block; width: 11px"></span>日<span
            style="display: inline-block; width: 11px"></span>期：</span>
        <el-input v-model="pObjs.BILLDATE" clearable size="mini" type="number" disabled />
        <!-- <span>{{ pObjs.BILLDATE }}</span> -->
      </el-col>
      <el-col :span="13">
        <span>流<span style="display: inline-block; width: 25px"></span>水<span
            style="display: inline-block; width: 20px"></span>号1：</span>
        <el-input size="mini" v-model="lsh" clearable v-focus placeholder="请扫流水号" @input="lshfocus"
          @focus="toggleKeyboard(1)">
          <template slot="append">
            <img slot="append" src="@/assets/img/sm.png" alt="" @click="getSaoma" style="background: #faa" />
          </template>
        </el-input>
      </el-col>
      <el-col :span="11">
        <span>流<span style="display: inline-block; width: 25px"></span>水<span
            style="display: inline-block; width: 20px"></span>号2：</span>
        <el-input size="mini" v-model="lsh2" clearable v-focus @input="lshfocus2" placeholder="请扫流水号"
          @focus="toggleKeyboard(2)">
        </el-input>
      </el-col>
      <el-col :span="13">
        <span>缸<span style="display: inline-block; width: 75px"></span>号：</span>
        <el-select v-model="pObjs.SUBBATCHNO" filterable clearable size="mini" placeholder="" @change="ganghao" disabled>
          <el-option v-for="item in ganghaos" :key="item.index" :label="item.SUBBATCHNO" :value="item.SUBBATCHNO" />
        </el-select>
      </el-col>
      <el-col :span="11">
        <span>产<span style="display: inline-block; width: 11px"></span>品<span
            style="display: inline-block; width: 11px"></span>型<span
            style="display: inline-block; width: 11px"></span>号：</span>
        <el-input size="mini" v-model="pObjs.PRODUCTID" clearable v-focus disabled placeholder="">
        </el-input>
      </el-col>
      <el-col :span="13">
        <span>数<span style="display: inline-block; width: 11px"></span>采<span
            style="display: inline-block; width: 11px"></span>米<span
            style="display: inline-block; width: 11px"></span>数：</span>
        <el-input v-model="scnum" clearable size="mini" :disabled="isdisabled" @input="numfocus"
          @focus="toggleKeyboard(3)" />
        <!-- <span>{{ scnum }}</span> -->
      </el-col>
      <el-col :span="11">
        <span>数<span style="display: inline-block; width: 11px"></span>采<span
            style="display: inline-block; width: 11px"></span>纬<span
            style="display: inline-block; width: 11px"></span>数：</span>
        <el-input v-model="scWnum" clearable size="mini" type="number" :disabled="isdisabled" @input="changescWnum"
          @focus="toggleKeyboard(4)" />
      </el-col>
      <el-col :span="13">
        <span>报<span style="display: inline-block; width: 15px"></span>工<span
            style="display: inline-block; width: 14px"></span>人<span
            style="display: inline-block; width: 14px"></span>1：</span>
        <el-input v-model="user.UidName" disabled clearable size="mini">
          <!-- <span>{{ user.UserId }}</span> -->
        </el-input>
      </el-col>
      <el-col :span="11">
        <span>报<span style="display: inline-block; width: 15px"></span>工<span
            style="display: inline-block; width: 14px"></span>人<span
            style="display: inline-block; width: 14px"></span>2：</span>
        <!-- <span>{{ user.PersonName }}</span> -->
        <el-select v-model="WorkersUsersID2" filterable clearable size="mini" placeholder="请选择" @change="changePer2">
          <el-option v-for="item in workLIst2" :key="item.PERSONID" :label="item.PERSONNAME" :value="item.PERSONID" />
        </el-select>
      </el-col>
      <el-col :span="13">
        <span>落<span style="display: inline-block; width: 11px"></span>布<span
            style="display: inline-block; width: 11px"></span>米<span
            style="display: inline-block; width: 11px"></span>数：</span>
        <el-input v-model="pObjs.HorseLength" clearable size="mini" type="number" disabled />
        <!-- <span>{{ pObjs.HorseLength }}</span> -->
      </el-col>
      <el-col :span="11">
        <span>生<span style="display: inline-block; width: 11px"></span>产<span
            style="display: inline-block; width: 11px"></span>设<span
            style="display: inline-block; width: 11px"></span>备：</span>
        <!-- <span>{{user.MachineId}}</span> -->
        <el-select v-model="sbei" filterable clearable size="mini" placeholder="请选择" @change="changeSbei">
          <el-option v-for="item in Sbei" :key="item.index" :label="item.EQUIPMENTID" :value="item.EQUIPMENTID" />
        </el-select>
      </el-col>
      <!-- <el-col :span="24">
        <span>机台号：</span>
        <span>{{ pObjs.WEAVDEVICEID }}</span>
      </el-col> -->
      <el-col :span="13">
        <span>报<span style="display: inline-block; width: 11px"></span>工<span
            style="display: inline-block; width: 11px"></span>米<span
            style="display: inline-block; width: 11px"></span>数：</span>
        <el-input v-model="input" clearable size="mini" type="number" :disabled="isdisabled" @input="numfocus"
          @focus="toggleKeyboard(5)" />
      </el-col>
      <el-col :span="11">
        <span>计
          <span style="display: inline-block; width: 11px"></span>划
          <span style="display: inline-block; width: 11px"></span>米
          <span style="display: inline-block; width: 11px"></span>数：
        </span>
        <el-input v-model="pObjs.QUANTITY" clearable size="mini" type="number" disabled />
        <!-- <span>{{ pObjs.QUANTITY }}</span> -->
      </el-col>
      <el-col :span="13">
        <span>理<span style="display: inline-block; width: 11px"></span>论<span
            style="display: inline-block; width: 11px"></span>纬<span
            style="display: inline-block; width: 11px"></span>数：</span>
        <el-input v-model="EVENWEFT" clearable size="mini" disabled type="number" @input="numfocus"
          @focus="toggleKeyboard(6)" />
      </el-col>
      <el-col :span="11">
        <span>生
          <span style="display: inline-block; width: 11px"></span>产
          <span style="display: inline-block; width: 11px"></span>日
          <span style="display: inline-block; width: 11px"></span>期：
        </span>
        <el-date-picker v-model="WorkerDate" type="date" clearable placeholder="选择日期" value-format="yyyyMMdd">
        </el-date-picker>
      </el-col>
    </el-row>
    <div class="btns">
      <el-button type="primary" @click="conmitSure" :loading="loading" size="mini">确定</el-button>
      <el-button type="success" @click="getNum" size="mini">获取数采</el-button>
      <el-button type="danger" @click="back" size="mini">返回</el-button>
    </div>
    <!-- 是否未报工 -->
    <el-dialog title="" :visible.sync="dialogVisible0" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        unmes
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="uncommit">确 定</el-button>
        <el-button @click="ungoBack" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 是否未报工 -->
    <el-dialog title="" :visible.sync="dialogVisible02" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        unmes2
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="uncommit2">确 定</el-button>
        <el-button @click="ungoBack2" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 流水号1是否已报工 -->
    <el-dialog title="" :visible.sync="dialogVisible" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        mes
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmit" :loading="loading">确 定</el-button>
        <el-button @click="goBack" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 流水号2是否已报工 -->
    <el-dialog title="" :visible.sync="dialogVisiblelsh" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        meslsh
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmit1" :loading="loading">确 定</el-button>
        <el-button @click="goBack2" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 判断匹长 -->
    <el-dialog title="" :visible.sync="dialogVisible1" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        mes1
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmitOk" :loading="loading">确 定</el-button>
        <el-button @click="cancel" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 验证宽机窄幅流水号是否填写 -->
    <el-dialog title="" :visible.sync="dialogVisible2" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">{{
        mes2
      }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmitOklsh" :loading="loading">确 定</el-button>
        <el-button @click="cancel2" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 理论纬数与数采纬数的判断 -->
    <el-dialog title="" :visible.sync="isdialogVisible1" width="30%" center>
      <span style="color: #f00; line-height: 0.8rem; font-size: 0.3rem">
        {{ lilunNum }}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" size="mini" @click="conmitOklu" :loading="loading">确 定</el-button>
        <el-button @click="cancel3" type="danger" size="mini">取 消</el-button>
      </span>
    </el-dialog>
    <!-- 扫码功能 -->
    <div class="code-reader-content" v-if="showvideo">
      <div class="page">
        <video ref="video" autoplay id="video"></video>
        <p v-if="videoInputDevicesArray.length == 0">{{ textContent }}</p>
      </div>
      <div class="scan-box">
        <div class="frame upper-left"></div>
        <div class="frame upper-right"></div>
        <div class="frame lower-right"></div>
        <div class="frame lower-left"></div>
        <div class="pointer-box">
          <div class="pointer"></div>
        </div>
        <div v-show="tipShow" class="tip">{{ tipMsg }}</div>
        <div class="btn-switch" @click="toggle">
          <span class="right" @click="colose()">关闭</span>
        </div>
      </div>
    </div>
    <!-- 键盘 -->
    <md-number-keyboard v-model="isKeyBoardShow[number]" @enter="onNumberEnter" @delete="onNumberDelete"
      @confirm="submit"></md-number-keyboard>
  </div>
</template>

<script>
// 引入插件
import { BrowserMultiFormatReader } from "@zxing/library";
import { api } from "../../api";
import { Cell, Notify } from "vant";
import localStorage from "../../api/localStorage";
import storage from "../../api/storage";

export default {
  name: "fiberOk",
  data() {
    return {
      // 关于扫码
      isdisabled: true,
      dialogVisible: false,
      dialogVisiblelsh: false,
      dialogVisible1: false,
      dialogVisible0: false,
      dialogVisible2: false,
      dialogVisible02: false,
      showvideo: false,
      codeReader: null,
      isdialogVisible1: false,
      tipMsg: "正在尝试识别....",
      tipShow: true,
      textContent: undefined,
      videoInputDevicesArray: [],
      deviceId: "",
      isEswitch: false,
      timer: null,
      WorkersUsersID2: "",
      workLIst2: [],
      input: 0,
      planinput: 0,
      lsh: "",
      lsh2: "",
      lilunNum: "",
      scnum: 0,
      scWnum1: 0,
      NowWeft: 0,
      scWnum: 0,
      pObjs: {},
      EquipmentID: 0,
      SUBBATCHNO: "",
      ganghaos: [],
      user: localStorage.getUser(),
      loading: false,
      WorkerDate:storage.getUser().WDate,
      mes: "",
      mes1: "",
      mes2: "",
      meslsh: "",
      unmes: "",
      EVENWEFT: 0,
      unmes2: "",
      Sbei: [],
      sbei: localStorage.getUser().MachineId,
      product: "",
      // 键盘
      number: null,
      isKeyBoardShow: [],
    };
  },
  created() {
    // this.$refs.saveTagInput.focus();
    console.log(this.user);
    this.pObjs = JSON.parse(this.$route.query.pObjs);
    console.log(this.pObjs);
    console.log(this.operation);
    this.GetEquipment();
    this.GetWorkUser();
  },
  destroyed() {
    // this.codeReader.stopContinuousDecode();
    // this.codeReader.reset();
  },
  watch: {
    $route: {
      handler() {
        this.user = storage.getUser();
        console.log(this.user.UserName);
        if (this.user.UserName == "管理员") {
          this.isdisabled = false
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  activated() {
    // this.$refs.saveTagInput.focus();
    console.log(this.user);
  },
  mounted() {
    this.GetZZWSInfoList();
  },
  methods: {
    // 数字键盘
    toggleKeyboard(index, item) {
      this.number = index;
      if (this.lsh === 0) {
        this.lsh = "";
      } else if (this.lsh2 === 0) {
        this.lsh2 = "";
      } else if (this.scnum === 0) {
        this.scnum = "";
      } else if (this.scWnum === 0) {
        this.scWnum = "";
      } else if (this.input === 0) {
        this.input = "";
      } else if (this.EVENWEFT === 0) {
        this.EVENWEFT = "";
      }
      this.$set(this.isKeyBoardShow, index, !this.isKeyBoardShow[index]);
    },
    onNumberEnter(val) {
      switch (this.number) {
        case 1:
          this.lsh = String(this.lsh) + val;
          this.ISZZQWork();
          break;
        case 2:
          this.lsh2 = String(this.lsh2) + val;
          this.ISZZQWork2();
          break;
        case 3:
          this.scnum = String(this.scnum) + val;
          this.input = this.scnum
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 4:
          this.scWnum = String(this.scWnum) + val;
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 5:
          this.input = String(this.input) + val;
          this.scnum = this.input
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 6:
          this.EVENWEFT = String(this.EVENWEFT) + val;
          break;

        // this.ISZZWorkPC();


      }
    },
    onNumberDelete() {
      switch (this.number) {
        case 1:
          this.lsh = String(this.lsh).substr(0, this.lsh.length - 1);
          break;
        case 2:
          this.lsh2 = String(this.lsh2).substr(0, this.lsh2.length - 1);
          break;
        case 3:
          this.scnum = String(this.scnum).substr(0, this.scnum.length - 1);
          this.input = this.scnum
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 4:
          this.scWnum = String(this.scWnum).substr(0, this.scWnum.length - 1);
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 5:
          this.input = String(this.input).substr(0, this.input.length - 1);
          this.scnum = this.input
          this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
          break;
        case 6:
          this.EVENWEFT = String(this.EVENWEFT).substr(0, this.EVENWEFT.length - 1);
          this.numfocus()
          break;
      }
    },
    submit() { },
    // 根据条件查找指定的纬纱缸号信息列表
    GetZZWSInfoList() {
      let params = {
        Page: 1,
        PageSize: 20,
        Entity: {
          BillID: this.pObjs.WEAVNO,
        },
      };
      console.log(params);
      api.GetZZWSInfoList(this.$qs.stringify(params)).then((res) => {
        console.log(res);
        this.ganghaos = res.data.Entities;
        console.log(this.ganghaos);
        this.pObjs.SUBBATCHNO =
          this.ganghaos[this.ganghaos.length - 1].SUBBATCHNO;
        console.log(this.pObjs.SUBBATCHNO);
      });
    },
    changeSbei(val) {
      console.log(val);
      // this.user.MachineId = val;
      this.GetEquipment();
    },
    GetEquipment() {
      let params = {
        EQUIPMENTID: this.sbei,
      };
      console.log(params);
      api.GetEquipment(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.Sbei = res.data;
      });
    },
    GetWorkUser() {
      api.GetWorkUser(this.WorkersUsersID2).then((res) => {
        console.log(res.data);
        if (res.data !== null) {
          this.workLIst2 = res.data;
        }
      });
    },
    changescWnum() {
      this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
    },
    numfocus(val) {
      console.log(val);
      this.scnum = val
      this.input = val
      this.scnum = this.input
      this.EVENWEFT = Math.floor((this.scnum * this.even) * 100)
    },
    changePer2(id) {
      console.log(id);
      if (id.length < 0) {
        this.WorkersUsersID2 = ""
        this.WorkersName2 = ""
      }
      if (this.workLIst2.length > 0) {
        this.workLIst2.map((item) => {
          console.log(item);
          console.log(id, item.PERSONID);
          if (id === item.PERSONID) {
            this.WorkersUsersID2 = item.PERSONID;
            this.WorkersName2 = item.PERSONNAME;
            console.log(this.WorkersUsersID2);
            console.log(this.WorkersName2);
          }
          // else {
          //   this.WorkersUsersID2 = ""
          // this.WorkersName2 = ""
          //   console.log(this.WorkersUsersID2);
          //   console.log(this.WorkersName2);
          // }
        })

        console.log(this.WorkersUsersID2);
        console.log(this.WorkersName2);
      }
    },

    // 扫任务书号
    getSaoma() {
      // console.log(1);
      this.showvideo = true;
      this.openScan();
      // console.log(2);
    },
    // 根据传入设备ID获取对应设备数产信息返回
    getNum() {
      let params = {
        code: this.sbei,
        WEAVNO: this.pObjs.WEAVNO,
      };
      api.GetZZSC(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        this.scWnum1 = res.data.WEFT;
        this.scnum = res.data.METRE;
        this.scWnum = res.data.WEFT;
        this.even = res.data.EVENWEFT;
        this.input = this.scnum;
        console.log(res.data.WEFT);
        this.NowWeft = res.data.NOW;
        console.log(res.data.NOW);
        this.EVENWEFT = this.scWnum1
      });
    },
    ganghao(val) {
      console.log(val);
    },
    lshfocus() {
      this.ISZZQWork();
    },
    lshfocus2() {
      this.ISZZQWork2();
    },
    // ISZZWork
    ISZZWork() {
      let params = {
        SERIALNO: this.lsh.trim(),
      };
      api.ISZZWork(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== true) {
        } else {
          this.dialogVisible = true;
          this.mes = res.data.Message;
        }
      });
    },
    ISZZQWork() {
      let params = {
        WEAVNO: this.pObjs.WEAVNO,
        SERIALNO: this.lsh.trim(),
      };
      api.ISZZQWork(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== true) {
          this.ISZZWork();
        } else {
          this.dialogVisible0 = true;
          this.unmes = res.data.Message;
        }
      });
    },
    // ISZZWork
    ISZZWork2() {
      let params = {
        SERIALNO: this.lsh2.trim(),
      };
      api.ISZZWork(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== true) {
        } else {
          this.dialogVisiblelsh = true;
          this.meslsh = res.data.Message;
          // return this.$message({
          //   message: res.data.Message,
          //   type: "success",
          // });
        }
      });
    },
    ISZZQWork2() {
      let params = {
        WEAVNO: this.pObjs.WEAVNO,
        SERIALNO: this.lsh2.trim(),
      };
      api.ISZZQWork(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== true) {
          this.ISZZWork2();
        } else {
          this.dialogVisible02 = true;
          this.unmes2 = res.data.Message;
        }
      });
    },
    goBack() {
      this.dialogVisible = false;
      this.lsh = "";
      // this.input = "";
    },
    conmit() {
      this.dialogVisible = false;
    },
    conmit1() {
      this.dialogVisiblelsh = false;
    },
    goBack2() {
      this.dialogVisiblelsh = false;
      this.lsh2 = "";
      // this.input = "";
    },
    uncommit() {
      this.dialogVisible0 = false;
      this.ISZZWork();
    },
    uncommit2() {
      this.dialogVisible02 = false;
      this.ISZZWork2();
    },
    ungoBack() {
      this.dialogVisible0 = false;
      this.lsh = "";
    },
    ungoBack2() {
      this.dialogVisible02 = false;
      this.lsh2 = "";
    },
    ISZZWorkPC() {
      let params = {
        SERIALNO: this.lsh.trim(),
        SERIALNO2: this.lsh2.trim(),
        InputNumber: this.input,
      };
      api.ISZZWorkPC(this.$qs.stringify(params)).then((res) => {
        console.log(res.data);
        if (res.data.Success !== true) {
          this.toBaogong();
        } else {
          this.dialogVisible1 = true;
          this.mes1 = res.data.Message;
          // this.toBaogong();
          // return this.$message({
          //   message: res.data.Message,
          //   type: "success",
          // });
        }
      });
    },
    cancel() {
      this.dialogVisible1 = false;
      // this.lsh = "";
      this.input = "";
    },
    cancel2() {
      this.dialogVisible2 = false;
      // this.lsh = "";
      this.input = "";
    },
    cancel3() {
      this.isdialogVisible1 = false;
      // this.lsh = "";
      // this.input = "";
    },
    conmitOk() {
      // this.dialogVisible1 = false;
      this.toBaogong();
    },
    conmitOklsh() {
      this.ISZZWorkPC();
    },
    lshfocus1() {
      // this.ISZZWorkPC();
    },

    conmitSure() {
      if ((this.EVENWEFT - this.scWnum) > 5000 || (this.EVENWEFT - this.scWnum) < -5000) {
        let params = {
          TheoryWEFT: this.EVENWEFT,
          MachineWeft: this.scWnum
        };
        api.ISZZWorkWeft(this.$qs.stringify(params)).then((res) => {
          console.log(res.data);
          if (res.data.Success !== false) {
            this.isdialogVisible1 = true;
            this.lilunNum = res.data.Message;
          } else {
            this.conmitOklu()
          }
        });
      } else {
        this.conmitOklu()
      }
    },
    conmitOklu() {
      let params = {
        ORGID: this.pObjs.ORGID,
        WEAVNO: this.pObjs.WEAVNO,
        BILLDATE: this.pObjs.BILLDATE,
        SERIALNO: this.lsh.trim(),
        SERIALNO2: this.lsh2.trim(),
        SUBBATCHNO: this.pObjs.SUBBATCHNO,
        InputNumber: this.input,
        MachineNumber: this.scnum,
        MachineWeft: this.scWnum,
        SCWeft: this.scWnum1,
        WorkersUsersID: this.user.UserId,
        WorkersName: this.user.PersonName,
        EQUIPMENTID: this.sbei,
        WorkersUsersID2: this.WorkersUsersID2,
        WorkersName2: this.WorkersName2,
        PRODUCTID: this.pObjs.PRODUCTID,
        // WEAVDEVICEID: this.pObjs.WEAVDEVICEID,
        CreatorId: this.user.PersonId,
        LastUpdateId: this.user.PersonId,
        NowWeft: this.NowWeft,
        PLANMETERNUM: this.pObjs.QUANTITY,
      };
      console.log(params);
      this.loading = true;
      api.ISSerialno(this.$qs.stringify(params)).then((res) => {
        // console.log(res.data);
        this.loading = false;
        if (res.data.Success !== true) {
          this.ISZZWorkPC();
        } else {
          this.dialogVisible2 = true;
          this.mes2 = res.data.Message;
          // this.toBaogong();
          // return this.$message({
          //   message: res.data.Message,
          //   type: "success",
          // });
        }
      });
    },
    // 报工
    toBaogong() {
      if (this.lsh !== this.lsh2) {
        if (this.scnum != 0 && this.scWnum != 0) {
          let params = {
            ORGID: this.pObjs.ORGID,
            WEAVNO: this.pObjs.WEAVNO,
            BILLDATE: this.pObjs.BILLDATE,
            SERIALNO: this.lsh.trim(),
            SERIALNO2: this.lsh2.trim(),
            SUBBATCHNO: this.pObjs.SUBBATCHNO,
            InputNumber: this.input,
            MachineNumber: this.scnum,
            MachineWeft: this.scWnum,
            WorkersUsersID: this.user.UserId,
            WorkersName: this.user.PersonName,
            EQUIPMENTID: this.sbei,
            WorkersUsersID2: this.WorkersUsersID2,
            WorkersName2: this.WorkersName2,
            PRODUCTID: this.pObjs.PRODUCTID,
            WorkerDate: this.WorkerDate,
            // WEAVDEVICEID: this.pObjs.WEAVDEVICEID,
            CreatorId: this.user.PersonId,
            LastUpdateId: this.user.PersonId,
            NowWeft: this.NowWeft,
            PLANMETERNUM: this.pObjs.QUANTITY,
            TheoryWeft: this.EVENWEFT
          };
          console.log(params);
          this.loading = true;
          api.ZZWorkSubmit(this.$qs.stringify(params)).then((res) => {
            console.log(res.data);
            this.loading = false;
            if (res.data.Success) {
              // if (this.pObjs.IsSZAutoSend === 1) {
              //   this.yes()
              // } else {
              // }
              // this.$router.go(-1);
              this.$router.push({
                path: "/zhizao",
              });
              return this.$message({
                showClose: true,
                message: res.data.Message,
                type: "success",
              });
            } else {
              return this.$message({
                showClose: true,
                message: res.data.Message,
                type: "error",
                // duration: 0
              });
            }
          });
        } else {
          return this.$message({
            message: "请先获取数采米数且数采米数，报工米数，数采纬数均不允许为0",
            type: "error",
          });
        }
      } else {
        return this.$message({
          message: "流水号1和流水号2不能相同",
          type: "error",
        });
      }
    },
    yes() {
      api.AGVCallbackOutStock(this.lsh.trim()).then((res) => {
        if (res.data.Success) {
          this.$router.go(-1);
          return this.$message({
            showClose: true,
            message: "操作成功",
            type: "success",
          });
        } else {
          return this.$message({
            showClose: true,
            message: res.data.Message,
            type: "error",
            // duration: 0
          });
        }
      });
    },
    back() {
      this.$router.push({
        path: "/zhizao",
      });
    },
    openScan() {
      this.codeReader = new BrowserMultiFormatReader();
      console.log(this.codeReader);
      this.codeReader
        .getVideoInputDevices()
        .then(async (videoInputDevices) => {
          this.tipShow = true;
          this.tipMsg = "正在尝试识别....";
          this.videoInputDevicesArray = videoInputDevices;
          //
          console.log("获取到的摄像头", this.videoInputDevicesArray);
          if (this.videoInputDevicesArray.length > 1) {
            this.deviceId = this.videoInputDevicesArray[1].deviceId;
            console.log(this.deviceId);
          } else {
            this.deviceId = this.videoInputDevicesArray[0].deviceId;
            console.log(this.deviceId);
          }
          this.decodeFromInputVideoFunc();
        })
        .catch(() => {
          this.tipShow = false;
        });
    },
    // 开始解码
    decodeFromInputVideoFunc() {
      if (this.videoInputDevicesArray.length == 0) {
        this.textContent = "初始化摄像头失败";
        document.getElementById("video").style.display = "none";
        return;
      }
      this.codeReader.reset();
      this.codeReader.decodeFromInputVideoDeviceContinuously(
        this.deviceId,
        "video",
        (result) => {
          this.tipMsg = "正在扫描";
          if (result) {
            if (result.text) {
              console.log("扫描成功", result.text);
              this.lsh = result.text;
              this.ISZZQWork();
              this.tipMsg = "扫描成功";
              this.showvideo = false;
              this.tipShow = true;
              window && window.getResultEvent(result);
              // window?.parent?.Gikam?.toast("扫码成功");
              // 关闭扫码功能
              this.codeReader.reset();
              this.codeReader.stopContinuousDecode();
            }
          }
        }
      );
    },
    cutover() {
      if (
        this.videoInputDevicesArray &&
        this.videoInputDevicesArray.length > 1
      ) {
        if (this.deviceId === this.videoInputDevicesArray[0].deviceId) {
          return (this.deviceId = this.videoInputDevicesArray[1].deviceId);
        } else {
          return (this.deviceId = this.videoInputDevicesArray[0].deviceId);
        }
      }
      this.codeReader.stopStreams();
      return;
    },
    // 切换摄像头
    async toggle() {
      this.codeReader.stopStreams();
      this.timer = setTimeout(() => {
        this.timer = null;
      }, 2000);
      if (this.timer) {
        await this.codeReader.tryPlayVideo("video");
        this.cutover();
        this.decodeFromInputVideoFunc();
      }
    },
    colose() {
      this.showvideo = false;
    },
  },
};
</script>
<style>
.el-select-dropdown__item {
  font-size: 0.4rem !important;
  height: 0.9rem;
  line-height: 0.9rem;
  /* top: 378px */
}

.el-select-dropdown {
  width: 5rem !important;
  min-width: 350px !important;
}

.el-popper {
  width: 5rem !important;
  min-width: 5rem !important;
}
</style>
<style scoped lang="less">
@deep: ~">>>";

.box {
  width: 100%;
  height: 100%;
  padding: 8px;
  box-sizing: border-box;
  overflow: hidden;
  // background: #eee;
  border: 1px solid #cecece;

  .el-row {
    background: #f8f8f8;
    padding: 0 8px;

    .el-col {
      display: flex;
      font-size: 0.4rem;
      padding: 0;
      height: 1rem;
      line-height: 1rem;
      border-bottom: 1px solid #d1d1d1;
      align-items: center;
      text-align: center;

      span {
        width: 90px;
        white-space: nowrap;
        text-align: left;
      }

      @{deep} .el-select {
        width: 180px;
        // width: 40%;
        // background: #80f405;
        margin-left: 5px;

        .el-input {
          width: 100%;
          margin-left: 0;
        }
      }

      @{deep} .el-input {
        // width: 40%;
        width: 180px;
        margin-left: 5px;
        // background: #80f405;

        .el-input__inner {
          height: 0.7rem;
          line-height: 0.7rem;
          font-size: 0.4rem;
          text-align: center;
          color: #000;
        }

        .el-input-group__append {
          right: 0rem;
          height: 0.65rem;
          line-height: 0.65rem !important;
          padding: 0;
          // background: #fff !important;
          border: 0;
        }
      }

      img {
        width: 0.7rem;
        height: 0.7rem !important;
        // top:0rem;
        background: #3c76ec;
      }
    }

    @{deep}.el-input--mini {
      .el-input__inner {
        font-size: 0.4rem !important;
      }
    }
  }

  .btns {
    width: 50%;
    display: flex;
    justify-content: space-between;
    margin: 0 auto;
    margin-top: 0.7rem;

    .el-button {
      width: 2.5rem;
      color: #fff !important;
    }

    .active {
      background: #80f405 !important;
    }

    .el-button--mini,
    .el-button--small {
      font-size: 0.4rem;
      color: #fff !important;
    }
  }

  .el-button--mini,
  .el-button--small {
    color: #fff !important;
  }

  .li {
    display: flex;
    justify-content: flex-start;
    flex-wrap: nowrap;
    height: 0.6rem;
    line-height: 0.6rem;

    img {
      // width: 0.7rem;
      height: 0.6rem !important;
      line-height: 0.6rem !important;
      background: #3c76ec;
    }

    span {
      width: 10%;
    }

    .el-input {
      height: 0.6rem;
      background-color: #eee;
      line-height: 0.6rem;

      @{deep} .el-input__inner {
        height: 0.6rem;
        background-color: #eee;
        line-height: 0.6rem;
        font-size: 0.4rem;
      }
    }

    @{deep} .el-select {
      border: 1px solid #cdcdcd;

      @{deep} .el-input__inner {
        height: 0.6rem;
        background-color: #eee;
        line-height: 0.6rem;
        // color: #fff;
      }
    }
  }
}

.code-reader-content {
  .page {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 100%;
    height: 100%;

    #video {
      height: 100%;
      width: 100%;
      object-fit: fill;
    }
  }

  .scan-box {
    position: absolute;
    left: 50%;
    top: 60%;
    transform: translate(-50%, -90%);
    height: 30%;
    width: 70%;

    .frame {
      position: absolute;
      width: 15px;
      height: 15px;
      border: 3px solid transparent;
    }

    .upper-left {
      top: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .upper-right {
      top: 0;
      right: 0;
      border-right-color: rgba(66, 133, 244, 1);
      border-top-color: rgba(66, 133, 244, 1);
    }

    .lower-right {
      bottom: 0;
      right: 0;
      border-bottom-color: rgba(66, 133, 244, 1);
      border-right-color: rgba(66, 133, 244, 1);
    }

    .lower-left {
      bottom: 0;
      left: 0;
      border-left-color: rgba(66, 133, 244, 1);
      border-bottom-color: rgba(66, 133, 244, 1);
    }

    .pointer-box {
      position: absolute;
      top: 0;
      left: 0;
      width: 98%;
      height: 100%;
      overflow: hidden;

      .pointer {
        height: 3px;
        background-image: linear-gradient(to right,
            transparent 0%,
            #afa 50%,
            transparent 100%);
        transform: translateY(-3px);
        animation: move 2s linear infinite;
      }

      @keyframes move {
        0% {
          transform: translateY(-3px);
        }

        100% {
          transform: translateY(calc(20vh - 3px));
        }
      }
    }

    .tip {
      position: absolute;
      left: 50%;
      top: 120%;
      transform: translate(-50%, 0);
      white-space: nowrap;
      // color: rgb(85, 209, 28);
      color: red;
      font-size: 16px;
    }

    .btn-switch {
      position: absolute;
      left: 50%;
      top: 140%;
      width: 50px;
      height: 20px;
      transform: translate(-50%, 0);
      background-color: #aaf;
      color: #fff;
      text-align: center;
      line-height: 20px;
      font-size: 12px;
      // background: url('../../../img/icon/switch.svg') no-repeat center;
    }
  }
}

@{deep} .el-icon-close:before {
  content: "" !important;
}

@{deep}.keyboard-number-item {
  font-size: 0.6rem !important;
}
</style>
